import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import SiteCreateForm from '../SiteCreateForm'
import { SiteForm } from '../../models/site.model'
import { getSite } from '../../services/site.service'
import TitlebarAction from '../common/TitlebarActions'
import { useProject } from '../../context/ProjectContext'
import { useNotification } from '../../context/NotificationContext'


interface SiteViewProps {
  site_code: string,
  setBlockScreen: (p: boolean) => void,
  setSuccessMessage: (n: any) => void,
}

const SiteView: React.FC<SiteViewProps> = ({
  site_code,
  setBlockScreen,
}) => {
    const { selectedProject } = useProject()
    const { showNotification } = useNotification();
  
    const [name, setName] = useState<string>('')
    const [siteForm, setSiteForm] = useState<SiteForm>({
      name: '',
      code: '',
      description: '',
      address: '',
      latitude: '',
      longitude: '',
      created_date: '',
    })

  const initComponent = () => {
    setBlockScreen(true);
    Promise.all([getSite(selectedProject, site_code)]).then(function (results) {
      setSiteForm(results[0]);
      setBlockScreen(false);
      setName(results[0].name);
    }).catch((error) => {
      showNotification(error.response.data)
      setBlockScreen(false);
    });
    setBlockScreen(false)
  }

  useEffect(initComponent, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSiteForm({
      ...siteForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setSiteForm({
      ...siteForm,
      [key]: value
    });
  }

  return (<>
    <TitlebarAction title={`Sitio: ${name}`} />
    <Box sx={{ marginX: '1vw' }}>

      <SiteCreateForm
        siteForm={siteForm}
        site_code={site_code}
        setBlockScreen={setBlockScreen}
        handleSelection={handleSelection}
        handleChange={handleChange}
        action='view'
      />

    </Box>
  </>);
}

export default SiteView